import { EReportPriority, EReportStatus, IMtDropdownData } from "@/interfaces";

export const vesselOverviewDataPoints: string[] = [
  "2961", // mode
  "2965", // along
  "2966", // athwart
  "2962", // Sub mode
  "2967", // Lat
  "2968", // Long
  "6183", // Heading
];

export const allLoadDataPoints: number[] = [
  1969, 2882, 2677, 2136, 2491, 2860, 2222, 2354, 2100, 1844, 5283, 5468, 6015, 6016, 6017, 6019,
  11309, 11421, 11532, 11640, 13547, 13548, 13549, 13550,
];

export const eAsogColors = {
  Green: "#13967C",
  Blue: "#1581C5",
  Yellow: "#CBB015",
  Red: "#F83B64",
};

export const timeIntervalsForPlayback: IMtDropdownData[] = [
  {
    name: "1 second",
    value: "1",
  },
  {
    name: "30 seconds",
    value: "30",
  },
  {
    name: "1 minute",
    value: "60",
  },
  {
    name: "30 minutes",
    value: "1800",
  },
  {
    name: "1 hour",
    value: "3600",
  },
];

export const generatorDataPoints = ["2856", "1955", "2000", "1871"];
export const engineDataPoints = ["2956", "2957", "2958", "2959"];
export const statusColors = {
  warning: "#FFA200",
  observation: "#0080FF",
  caution: "#FFE600",
  danger: "#FF381A",
  ok: "#32CD32",
};
export const systems = ["IBS", "DPS", "CBM", "TCS"];

export const prioritiesList: IMtDropdownData[] = [
  {
    name: "High",
    value: EReportPriority.High.toString(),
  },
  {
    name: "Medium",
    value: EReportPriority.Medium.toString(),
  },
  {
    name: "Low",
    value: EReportPriority.Low.toString(),
  },
  {
    name: "None",
    value: EReportPriority.None.toString(),
  },
];
export const statusList: IMtDropdownData[] = [
  {
    name: "Open",
    value: EReportStatus.Open.toString(),
  },
  {
    name: "Closed",
    value: EReportStatus.Closed.toString(),
  },
  {
    name: "On Hold",
    value: EReportStatus.OnHold.toString(),
  },
];
export const failuresList: IMtDropdownData[] = [
  { name: "Break", value: "break" },
  { name: "Wear", value: "wear" },
  { name: "Corrosion", value: "corrosion" },
  { name: "Erosion", value: "erosion" },
  { name: "Fatigue", value: "fatigue" },
  { name: "Distortion", value: "distortion" },
  { name: "Fatigue", value: "fatigue" },
  { name: "Mechanical Failure", value: "mechanical-failure" },
  { name: "Bearing Defect", value: "bearing-defect" },
  { name: "Electric", value: "electric" },
  { name: "Mechanical imbalance", value: "mechanical-imbalance" },
  { name: "Mechanical looseness", value: "mechanical-looseness" },
  { name: "Mechanical misalignment", value: "mechanical-misalignment" },
  { name: "Mechanical bearings", value: "mechanical-bearings" },
  { name: "Thermal", value: "thermal" },
  { name: "Lubrication", value: "lubrication" },
];
export const causesList: IMtDropdownData[] = [
  { name: "Human Error", value: "human" },
  { name: "Design Failure", value: "design" },
  { name: "Manufacturing Failure", value: "manufacturing" },
  { name: "Operation Failure", value: "operation" },
  { name: "Inadequate Maintenance", value: "maintenance" },
];

export const vesselTypes: IMtDropdownData[] = [
  { value: "PSV", name: "Platform Support Vessel" },
  { value: "OSV", name: "Offshore Support Vessel" },
  { value: "SOV", name: "Service Operation Vessel" },
  { value: "CSOV", name: "Commissioning Service Operation Vessel" },
  { value: "AHTS", name: "Anchor Handling Tug Support" },
  { value: "DVS", name: "Diving Support Vessel" },
  { value: "SV", name: "Survey Vessel" },
  { value: "RoRo", name: "Roll on/Roll off" },
  { value: "Fishing Vessel", name: "Fishing Vessel" },
  { value: "Fracture/Stimulation", name: "Fracture/Stimulation" },
  { value: "Accommodation", name: "Accommodation" },
  { value: "Crew Boat", name: "Crew Boat" },
  { value: "Bulk Carrier", name: "Bulk Carrier" },
  { value: "Bulk Vessel", name: "Bulk Vessel" },
  { value: "Gas Carrier", name: "Gas Carrier" },
  { value: "Drill Ship", name: "Drill Ship" },
  { value: "Ferry", name: "Ferry" },
  { value: "Container Ship", name: "Container Ship" },
  { value: "Container Ship small feeder", name: "Container Ship small feeder" },
  { value: "Container ship feeder", name: "Container ship feeder" },
  { value: "Container Ship feeder max", name: "Container Ship feeder max" },
  { value: "Container ship panamax", name: "Container ship panamax" },
  { value: "Container Ship post-Panmax", name: "Container Ship post-Panmax" },
  { value: "Container ship Neopanamax", name: "Container ship Neopanamax" },
  { value: "Container Ship untra large", name: "Container Ship untra large" },
];

export const classSocieties: IMtDropdownData[] = [
  { value: "ABS", name: "AMERICAN BUREAU OF SHIPPING (ABS)" },
  { value: "BUREAU VERITAS", name: "BUREAU VERITAS" },
  { value: "NKK", name: "CLASS NKK" },
  { value: "DNV", name: "DNV" },
  { value: "INSB", name: "INTERNATIONAL NAVAL SURVEYS BUREAU (INSB)" },
  { value: "KR", name: "KOREAN REGISTER OF SHIPPING (KR)" },
  { value: "LR", name: "LLOYD'S REGISTER GROUP LIMITED (LR)" },
  { value: "PRS", name: "POLISH REGISTER OF SHIPPING (PRS)" },
  { value: "RINA", name: "REGISTRO ITALIANO NAVALE (RINA)" },
];

export const designSeries: IMtDropdownData[] = [
  { value: "270", name: "ECO 270" },
  { value: "312", name: "ECO 312" },
  { value: "280", name: "ECO 280" },
  { value: "140.38", name: "ECO 140.38" },
  { value: "102.5", name: "ECO 102.5" },
  { value: "307", name: "ECO 307" },
  { value: "316.5", name: "ECO 316.5" },
  { value: "348", name: "ECO 348" },
  { value: "288", name: "ECO 288" },
  { value: "275", name: "ECO 275" },
  { value: "299", name: "ECO 299" },
  { value: "272", name: "ECO 272" },
  { value: "244", name: "ECO 244" },
  { value: "260", name: "ECO 260" },
  { value: "360", name: "ECO 360" },
  { value: "300", name: "ECO 300" },
  { value: "220", name: "ECO 220" },
  { value: "155.55", name: "ECO 155.55" },
  { value: "75", name: "ECO 75" },
  { value: "90", name: "ECO 90" },
  { value: "102", name: "ECO 102" },
  { value: "110", name: "ECO 110" },
];
